export default class Point {
    public x: number;
    public y: number;

    constructor(x = 0, y = 0) {
        this.x = x;
        this.y = y;
    }

    public clone(): Point {
        return new Point(this.x, this.y);
    }

    public toString(): string {
        return this.x.toString() + "," + this.y.toString();
    }

    public add(point: Point) {
        const toReturn = this.clone();
        toReturn.x += point.x;
        toReturn.y += point.y;

        return toReturn;
    }
}
